import React, { useState } from 'react';
import { ConfirmFlexModal, Input, Label, LinkButtonAria, SVGCheckbox } from '@riac/design-system';
import { Link } from 'react-router-dom';

export const ValidateBidderModal = ({ stateNoticeText, onConfirm, onReject }) => {
  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [checkState, setCheckState] = useState<boolean>(false);
  const [checkTC, setCheckTC] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');

  const handleConfirm = () => {
    // validate all the good stuff
    let valid = true;
    if(!firstName || !lastName || firstName.length < 1 || lastName.length < 1) {
      valid = false;
    }
    if(stateNoticeText.length > 0 && !checkState) {
      valid = false;
    }
    if(!checkTC) {
      valid =false;
    }

    if(valid) {
      onConfirm(`${firstName} ${lastName}`);
    } else {
      setMessage('You must type your full name and check all checkboxes');
    }
  };

  const handleReject = () => {
    onReject(false);
  };

  return (<ConfirmFlexModal
    title={'Agree to Terms'}
    isOpen={true}
    confirmButtonText={'Place'}
    onConfirm={handleConfirm}
    rejectButtonText={'Cancel'}
    onReject={handleReject}
  >
    <div style={{ width: '100%' }}>
      <p className='text-grey-25'>
        Payment is due upon notification. I understand that if payment is not received within 15 days of
        notification either verbally or written I authorize Rock Island Auction Company to charge my credit
        card for full payment. If Rock Island Auction Company has a credit card on file from prior activity
        with Rock Island Auction Company, by the submission of my bids, RIAC is authorized to charge the
        credit card on file.
      </p>
      <p className='text-grey-25'>
        State sales tax regulations and requirements have changed for certain states. Please refer to the{' '}
        <LinkButtonAria className='text-gold-600 hover:text-gold-700' to="/terms-and-conditions" target="_blank">
          RIAC Terms and Conditions
        </LinkButtonAria> for additional information.
      </p>
      {stateNoticeText.length > 0
        &&
          <SVGCheckbox
            checked={checkState}
            className='mt-3'
            onChange={() => setCheckState(!checkState)}
            label={stateNoticeText[0].NoticeText}
          />
      }
      <SVGCheckbox
        checked={checkTC}
        className='mt-3'
        onChange={() => setCheckTC(!checkTC)}
        label={<span>I agree to the Terms & Conditions. <LinkButtonAria className='text-gold-600 hover:text-gold-700' to="/terms-and-conditions" target="_blank">
          Click here to read the Terms & Conditions
        </LinkButtonAria>.</span>}
      />
      <p className='text-grey-25 mt-3'>
        NOTICE: Our terms and conditions have changed effective 9/16/2024, including a changes to Buyer's Premium, Fees,
        and Shipping. Please review the new terms and conditions before bidding.
      </p>
      <p className='text-grey-25 mt-3'>
        By typing my name in the fields below, I acknowledge that it is the same as my signature.
      </p>
      <form onSubmit={(e) => e.preventDefault()}>
        <Input type="text" label="First Name:" inverted={true} value={firstName} autoComplete='given-name' onChange={(e) => setFirstName(e)} required/>
        <Input type="text" label="Last Name:" inverted={true} value={lastName} autoComplete='family-name' onChange={(e) => setLastName(e)} required/>
      </form>

      {message && <p className={'bg-red-600 text-white p-2'}>{message}</p>}</div>
  </ConfirmFlexModal>);
};
